import {
  ScheduleEventType,
  SCHEDULE_EVENT_TYPE_CSS
} from '@/constants/schedule'

export const eventType2Css = (eventType: ScheduleEventType) =>
  SCHEDULE_EVENT_TYPE_CSS[eventType] ||
  SCHEDULE_EVENT_TYPE_CSS[ScheduleEventType.SCHEDULE_EVENT_TYPE_DIALYSIS]
